import Vue from "vue";
import Vuex from "vuex";
import firebase from 'firebase'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: null,
    },
    workorders: []
  },
  getters: {
    user(state){
      return state.user
    }
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    SET_WORKORDERS(state, workorders) {
      if (workorders) {
        state.workorders = workorders;        
      } else {
        state.workorders
      }
    }
  },
  actions: {
    fetchUser({ commit }, user) {
      const workordersDB = firebase.firestore().collection('workorders');
      commit("SET_LOGGED_IN", user !== null);
      // realtime updates from our posts collection
      workordersDB.orderBy('createdOn', 'desc').onSnapshot(querySnapshot => {
        let workordersArray = []

        querySnapshot.forEach(doc => {
            let wo = doc.data()
            wo.id = doc.id
            workordersArray.push(wo)
        })

        commit('SET_WORKORDERS', workordersArray)
    })
      if (user) {
        commit("SET_USER", {
          displayName: user.displayName,
          email: user.email
        });
      } else {
        commit("SET_USER", null);
      }
    }
  }
});